// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"783":"film-thickness","895":"tools"}[chunkId] + ".css";
};